export const GET_RECOMMENDED_ITEMS = "GET_RECOMMENDED_ITEMS";
export const GET_RECOMMENDED_ITEMS_SUCCESS = "GET_RECOMMENDED_ITEMS_SUCCESS";
export const GET_RECOMMENDED_ITEMS_FAIL = "GET_RECOMMENDED_ITEMS_FAIL";
export const CLEAR_RECOMMENDED_ITEMS = "CLEAR_RECOMMENDED_ITEMS";

